import { createAsyncMutation } from '@/utils/async';

export const GET_PROBLEM_HINTS = createAsyncMutation('GET_PROBLEM_HINTS');
export const GET_SCHEMES = createAsyncMutation('GET_SCHEMES');
export const GET_STARTUP_TEMPLATES = createAsyncMutation('GET_STARTUP_TEMPLATES');
export const GET_CONFIG_ACTION_PLANS = createAsyncMutation('GET_CONFIG_ACTION_PLANS');
export const SET_COMPANY = 'SET_COMPANY';
export const SET_SEND_USER_EMAIL_LOADING = 'SET_SEND_USER_EMAIL_LOADING';
export const GET_CONFIG_USERS = createAsyncMutation('GET_CONFIG_USERS');

export default {
  GET_PROBLEM_HINTS,
  GET_SCHEMES,
  GET_STARTUP_TEMPLATES,
  GET_CONFIG_ACTION_PLANS,
  SET_COMPANY,
  SET_SEND_USER_EMAIL_LOADING,
  GET_CONFIG_USERS,
};
